import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    if (window.location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section footer-logo">
            <img 
              src="/logo-black-HR-Consol.png" 
              alt="Hrconsol" 
              className="footer-logo-img"
            />
          </div>
          
          <div className="footer-section footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <button 
                  className="footer-link" 
                  onClick={() => scrollToSection('home')}
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  className="footer-link" 
                  onClick={() => scrollToSection('services')}
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  className="footer-link" 
                  onClick={() => scrollToSection('about')}
                >
                  About
                </button>
              </li>
              <li>
                <button 
                  className="footer-link" 
                  onClick={() => scrollToSection('contact')}
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div className="footer-section footer-services">
            <h3>Our Services</h3>
            <ul>
              <li>
                <button 
                  className="footer-link" 
                  onClick={() => navigate('/executive-search')}
                >
                  Executive Search
                </button>
              </li>
              <li>
                <button 
                  className="footer-link" 
                  onClick={() => navigate('/tech-recruitment')}
                >
                  Tech Recruitment
                </button>
              </li>
              <li>
                <button 
                  className="footer-link" 
                  onClick={() => navigate('/rpo')}
                >
                  RPO Services
                </button>
              </li>
              <li>
                <button 
                  className="footer-link" 
                  onClick={() => navigate('/labour-contractor')}
                >
                  Labour Contractor
                </button>
              </li>
              <li>
                <button 
                  className="footer-link" 
                  onClick={() => navigate('/payroll-outsourcing')}
                >
                  Payroll Outsourcing
                </button>
              </li>
            </ul>
          </div>

          <div className="footer-section footer-services">
            <h3>More Services</h3>
            <ul>
              <li>
                <button 
                  className="footer-link" 
                  onClick={() => navigate('/startup-consultancy')}
                >
                  Startup Consultancy
                </button>
              </li>
              <li>
                <button 
                  className="footer-link" 
                  onClick={() => navigate('/od-consultancy')}
                >
                  OD Consultancy
                </button>
              </li>
              <li>
                <button 
                  className="footer-link" 
                  onClick={() => navigate('/performance-management')}
                >
                  Performance Management
                </button>
              </li>
              <li>
                <button 
                  className="footer-link" 
                  onClick={() => navigate('/hr-policy-management')}
                >
                  HR Policy Management
                </button>
              </li>
              <li>
                <button 
                  className="footer-link" 
                  onClick={() => navigate('/training-solutions')}
                >
                  Training Solutions
                </button>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} HRCONSOL. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
